import * as $ from "jquery";
const empty = require('is-empty');

export const CheckNipHasChanged = (() => {
	$.validator.addMethod("checkNipHasChanged", function(value, element, param)  {
			if ($(element).attr('data-value') === undefined) {
				return true
			};
			let oldNip = $(element).attr('data-value');
			return oldNip === value;
		},
		$.validator.format("Numer NIP się zmienił. Pobierz ponownie dane firmy."));
})();import * as $ from "jquery";
const empty = require('is-empty');

export const CheckNipHasChanged = (() => {
	$.validator.addMethod("checkNipHasChanged", function(value, element, param)  {
			if ($(element).attr('data-value') === undefined) {
				return true
			};
			let oldNip = $(element).attr('data-value');
			return oldNip === value;
		},
		$.validator.format("Numer NIP się zmienił. Pobierz ponownie dane firmy."));
})();